// it seems this component is no longer used in the project. perhaps delete the file?
angular.module('app').component('testWaiver', {
    bindings: {
        selectedItems: '<'
    },
    templateUrl: 'scripts/app/partials/TraceDetails/Waiver/test-waiver.tpl.html',
    controllerAs: 'vm',
    controller: function (WaiverServiceApi, ConnectedUserService) {
        let vm = this;
        vm.getWaiver = getWaiver;
        // binding variables
        let selectedItems;
        // controller variables
        let user;
        this.$onInit = function () {
            ConnectedUserService.get().then(function (response) {
                user = response;
                vm.user = user;
            });
        };
        this.$onChanges = function (changes) {
            if (changes.selectedItems) {
                selectedItems = changes.selectedItems.currentValue;
                getWaiver(selectedItems);
            }
        };
        function getWaiver(selectedItems) {
            // Toggle Waiver  Form
            vm.showWaiverForm = false;
            // Initialise for moving next/prev test
            vm.waiverDisabled = false;
            // If we don't have any selected items then just return
            if (angular.isUndefined(selectedItems)) {
                return null;
            }
            // Refresh waiver
            let waiverRequest = createWaiverRequest(selectedItems);
            return WaiverServiceApi.waiverWithNotes(waiverRequest).then(function (response) {
                let waiverWithNotes = response.data;
                vm.waiverWithNotes = waiverWithNotes;
                // Disable the waiver button if the waiver has been approved
                if (waiverWithNotes.HasWaiver) {
                    vm.waiverDisabled =
                        waiverWithNotes.Waiver.WaiverStatus === 1;
                }
                vm.waiverStatus = getWaiverStatus(waiverWithNotes);
            });
        }
        function getWaiverStatus(waiverWithNotes) {
            let status = waiverWithNotes.Waiver.WaiverStatus;
            switch (status) {
                case 0:
                    return 'Waiver request outstanding';
                case 1:
                    return 'Waiver approved';
                case 2:
                    return 'Waiver request denied';
                default:
                    return '';
            }
        }
        function createWaiverRequest(selectedItems) {
            if (angular.isUndefined(selectedItems)) {
                return null;
            }
            let waiverRequest = {
                // TODO: We need to get the iteration
                TesterId: selectedItems.selectedTester.Id,
                SimId: selectedItems.selectedSim.Id,
                SuiteId: selectedItems.selectedSuite.Id,
                TestId: selectedItems.selectedTest.Id,
                ProjectIterationId: selectedItems.projectIterationId
            };
            return waiverRequest;
        }
    },
});
